/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useRef, useState } from 'react';
import style from './upload.module.scss';
import { UploadInterface } from './uploadTypes';
import PlusButton from '../plusButton/plusButtonComponent';
import EditButton from '../editButton/editButtonComponent';
import { EDIT_BUTTON_TYPE } from '../editButton/editButtonTypes';
import TrashButton from '../trashButton/trashButtonComponent';
import '../../constants/_global.scss';

const UploadComponent: React.FC<UploadInterface> = ({
  width,
  photo,
  name,
  onChange,
  onDelete,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (photo) {
      setImageUrl(photo);
      console.log(photo);
    }
  }, [photo]);

  const customWidth = {
    width: width ? `${width}px` : '100%',
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setImageUrl(reader.result as string);
        if (onChange) {
          onChange(event);
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDeleteClick = () => {
    console.log(`name is ${name}`);
    if (name && onDelete) {
      onDelete(name);
    }
    setImageUrl(null);
  };

  const handleEditClick = async () => {
    if (fileRef.current) {
      fileRef.current.value = '';
      fileRef.current.click();
    }
  };

  const mainStyle = {
    maxWidth: width ? `${width}px` : '343px',
    margin: '0',
    width: '100%',
  };

  const Upload = () => (
    <button
      className={style.upload}
      onClick={handleUploadClick}
      type="button"
      style={mainStyle}
    >
      <input
        type="file"
        className={style.hiddenInput}
        ref={fileInputRef}
        onChange={handleFileChange}
        name={name ?? 'img'}
      />
      <div className={style.withSpanUpload}>
        <div className={style.input}>
          <PlusButton />
        </div>
        <span className="spanGlobal">Добавить фото</span>
      </div>
    </button>
  );

  const Edit = () => {
    let backgroundStyle = {};

    if (imageUrl) {
      backgroundStyle = {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };
    }

    return (
      <div className={style.editContainer}>
        <div className={style.edit} style={backgroundStyle}>
          <div className={style.overlay}>
            <div className={style.twoButtons}>
              <div className={style.withSpanEdit}>
                <div className={style.button}>
                  <EditButton
                    onClick={handleEditClick}
                    ver={EDIT_BUTTON_TYPE.SECONDARY}
                    animation={false}
                  />
                </div>
                <span className="spanGLobal">Изменить</span>
              </div>
              <div className={style.withSpanEdit}>
                <div className={style.button}>
                  <TrashButton onClick={handleDeleteClick} animation={false} />
                </div>
                <span className="spanGlobal">Удалить</span>
              </div>
            </div>
          </div>
        </div>
        <input
          type="file"
          className={style.hiddenInput}
          ref={fileRef}
          onChange={handleFileChange}
          name={name ?? 'img'}
        />
      </div>
    );
  };

  return <div style={mainStyle}>{!imageUrl ? <Upload /> : <Edit />}</div>;
};

export default UploadComponent;
